import { useState, useEffect } from 'react'

const useScreenResize = () => {
  const [screenSize, setScreenSize] = useState({ size: '2xl' })

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        setScreenSize({ size: 'xs' })
      } else if (window.innerWidth >= 640 && window.innerWidth < 768) {
        setScreenSize({ size: 'sm' })
      } else if (window.innerWidth >= 768 && window.innerWidth < 1024) {
        setScreenSize({ size: 'md' })
      } else if (window.innerWidth >= 1024 && window.innerWidth < 1280) {
        setScreenSize({ size: 'lg' })
      } else if (window.innerWidth >= 1280 && window.innerWidth < 1536) {
        setScreenSize({ size: 'xl' })
      } else if (window.innerWidth >= 1536) {
        setScreenSize({ size: '2xl' })
      }
    }

    window.addEventListener('resize', handleResize)
    handleResize() // Set initial size
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return screenSize
}

export default useScreenResize
